import { computed, observable, makeObservable } from "mobx";
import UsuarioStore from './UsuarioStore';
import { Processo, TipoControle, TipoMinuta } from "../modelo";
import { MINUTA_DEVOLVIDA, SituacaoMinuta } from "../modelo/SituacaoMinuta";
import ControleGabineteStore from "./ControleGabineteStore";
import ProcessoStore from "./ProcessoStore";
import RouterStore from "./RouterStore";
import FiltroStore from './FiltroStore';
import PautaRevisaoStore from "./PautaRevisaoStore";
import { filtrarPorOjc } from "../misc/HelperFiltrarPorOJC";

class EscaninhoStore {
    cardPrincipalExpanded = false;
    expandedCardClasse = true;
    expandedCardFase = true;
    expandedCardIndicadores = false;
    expandedCardOJC = false;

    classeSelecionada;
    faseSelecionada;
    indicadorSelecionado;
    OJCSelecionado;

    constructor() {
        makeObservable(this, {
            cardPrincipalExpanded: observable,
            expandedCardClasse: observable,
            expandedCardFase: observable,
            expandedCardIndicadores: observable,
            expandedCardOJC: observable,
            tipoEscaninho: computed,
            aguardandoPeticoesPendentes: computed,
            totalUnidade: computed,
            processosPorTipoEscaninhoFiltrado: computed,
            processosSelecionados: computed,
            processosSelecionadosTirandoMinutaDevolvidas: computed,
            processosSelecionadosApenasComMinutaDevolvidasSelecionadas: computed,
            processosPorTipoEscaninho: computed,
            qtdProcessos: computed
        });
    }

    get aguardandoPeticoesPendentes() {
        return RouterStore.isEscaninhoPeticao && ProcessoStore.carregandoPeticoesPendentesEscaninho;
    }

    get tipoEscaninho() {
        const rota = RouterStore.rotaAtual || RouterStore.lastRoute || window.location.pathname;
        if (rota?.includes('escaninho')) {
            const tipoEscaninho = rota.split('/');
            return tipoEscaninho[tipoEscaninho.length - 1].split('?')[0];
        }
        return '';
    }

    get totalUnidade() {
        return ProcessoStore._processos.filter(proc => proc.noFluxoCerto).length;
    }

    // @observable processosPorTipoEscaninho: Processo[] = [];

    get processosPorTipoEscaninhoFiltrado() {
        if (this.tipoEscaninho === 'gerencial' && FiltroStore.processosPreparados !== undefined) {
            return FiltroStore.processosPreparados;
        }
        let lista = this.processosPorTipoEscaninho.filter(processo => processo.mostrar);

        if (RouterStore.isEscaninhoPauta && PautaRevisaoStore.filtroAutorizacao !== 'todos') {
            const querAutorizados = PautaRevisaoStore.filtroAutorizacao === 'autorizados';
            lista = lista.filter(processo =>
                PautaRevisaoStore.isAutorizado(processo.identificadorProcesso) === querAutorizados);
        }

        return lista;
    }

    get processosSelecionados() {
        return this.processosPorTipoEscaninhoFiltrado.filter(processo => processo.selecionado && processo.mostrar);
    }

    get processosSelecionadosTirandoMinutaDevolvidas(): Processo[] {
        return this.processosSelecionados.filter(processo => {
            const minutasDevolvidas = processo.minutas.filter(min =>
                min.situacaoMinuta?.codigo === (new MINUTA_DEVOLVIDA()).codigo
            );

            return processo.selecionado && processo.minutas.length > minutasDevolvidas.length;
        });
    }

    get processosSelecionadosApenasComMinutaDevolvidasSelecionadas(): Processo[] {
        return this.processosSelecionados.filter(processo => {
            const minutasDevolvidas = processo.minutas.filter(min =>
                min.situacaoMinuta?.codigo === (new MINUTA_DEVOLVIDA()).codigo
            );

            return processo.selecionado && (minutasDevolvidas.length > 0);
        });
    }


    get processosPorTipoEscaninho() {
        if (FiltroStore.preparandoEscaninho && !RouterStore.isEscaninhoPauta) {
            return [];
        }
        let processos = ProcessoStore.processosAgrupados.slice();
        let controleNumero;
        let responsavel;
        let responsavelParam;
        let situacaoMinuta;
        let ojc;
        switch (this.tipoEscaninho) {
            case 'gerencial':
            case 'dashboard':
                controleNumero = RouterStore.getParam('controleNumero')[0] === 'null' ? undefined : RouterStore.getParam('controleNumero')[0];;
                responsavelParam = RouterStore.getParam('responsavel')[0];
                responsavel = responsavelParam === 'null' ? undefined : responsavelParam?.toString().trim();
                ojc = RouterStore.getParam('OJC')[0] === 'null' ? undefined : RouterStore.getParam('OJC')[0];
                if (responsavelParam === 'null') {
                    processos = processos.filter(proc => {
                        const cpf = proc.numeroCpfResponsavel?.toString().trim();
                        return !cpf;
                    });
                } else if (responsavel) {
                    processos = processos.filter(proc => {
                        const cpfProcesso = proc.numeroCpfResponsavel?.toString().trim();
                        return cpfProcesso === responsavel;
                    });
                }
                if (controleNumero) {
                    const numero = parseInt(controleNumero);
                    processos = processos.filter(proc => {
                        return proc.controleGabinete?.numero === numero;
                    });
                }
                if (ojc) {
                    processos = filtrarPorOjc(processos, ojc);
                }
                break;
            case 'assinatura':
            case 'assinaturaNova':
                if (processos?.length > 0 && (UsuarioStore?.ehSecretario || UsuarioStore?.ehLocalizacaoSecretaria)) {
                    processos = processos.filter(proc => {
                        return proc.minutas.find(minuta =>
                            (minuta.tipo.codigo === TipoMinuta.ATO_ORDINATORIO || minuta.tipo.codigo === TipoMinuta.DESPACHO || minuta.tipo.codigo === TipoMinuta.DECISAO) && minuta.situacaoMinuta.codigo >= SituacaoMinuta.LIBERADA_PARA_ASSINATURA_OU_INCLUSAO_EM_PAUTA &&
                            minuta.situacaoMinuta.codigo < SituacaoMinuta.ARQUIVADA)
                    })
                } else {
                    processos = processos.filter(proc => {
                        return proc.minutas.find(minuta =>
                            minuta.tipo.codigo !== TipoMinuta.VOTO &&
                            minuta.tipo.codigo !== TipoMinuta.VOTO_FASE_FUTURA &&
                            minuta.situacaoMinuta.codigo >= SituacaoMinuta.LIBERADA_PARA_ASSINATURA_OU_INCLUSAO_EM_PAUTA &&
                            minuta.situacaoMinuta.codigo < SituacaoMinuta.ARQUIVADA
                        );
                    });
                }
                /*processos = processos.filter(proc => {
                    if (UsuarioStore !== undefined && UsuarioStore?.ehSecretario) {
                        return proc.minutas.find(minuta =>
                            minuta.tipo.codigo === TipoMinuta.ATO_ORDINATORIO && minuta.situacaoMinuta.codigo >= SituacaoMinuta.LIBERADA_PARA_ASSINATURA_OU_INCLUSAO_EM_PAUTA &&
                            minuta.situacaoMinuta.codigo < SituacaoMinuta.ARQUIVADA)
                    } else {
                        return proc.minutas.find(minuta =>
                            minuta.tipo.codigo !== TipoMinuta.VOTO &&
                            minuta.tipo.codigo !== TipoMinuta.VOTO_FASE_FUTURA &&
                            minuta.situacaoMinuta.codigo >= SituacaoMinuta.LIBERADA_PARA_ASSINATURA_OU_INCLUSAO_EM_PAUTA &&
                            minuta.situacaoMinuta.codigo < SituacaoMinuta.ARQUIVADA
                    );
                }})*/
                break;
            case 'usuario':
                processos = processos.filter(proc => {
                    return proc.numeroCpfResponsavel === UsuarioStore.login;
                });
                break;
            case 'vistos':
                processos = processos.filter(proc => {
                    const minuta = proc.minutas.find(minuta => minuta.tipo?.codigo === TipoMinuta.VOTO
                        && minuta.situacaoMinuta.codigo === SituacaoMinuta.LIBERADA_PARA_ASSINATURA_OU_INCLUSAO_EM_PAUTA
                        && !minuta.vistoLiberado);
                    return minuta;
                });
                break;
            case 'filtrado':
                controleNumero = RouterStore.getParam('controleNumero')[0];
                responsavelParam = RouterStore.getParam('responsavel')[0];
                responsavel = responsavelParam === 'null' ? undefined : responsavelParam?.toString().trim();
                situacaoMinuta = RouterStore.getParam('situacaoMinuta')[0] === 'null' ? undefined : RouterStore.getParam('situacaoMinuta')[0];
                ojc = RouterStore.getParam('OJC')[0] === 'null' ? undefined : RouterStore.getParam('OJC')[0];
                if (responsavelParam === 'null') {
                    processos = processos.filter(proc => {
                        const cpf = proc.numeroCpfResponsavel?.toString().trim();
                        return !cpf;
                    });
                } else if (responsavel) {
                    processos = processos.filter(proc => {
                        const cpfProcesso = proc.numeroCpfResponsavel?.toString().trim();
                        return cpfProcesso === responsavel;
                    });
                }
                if (controleNumero) {
                    const numero = parseInt(controleNumero);
                    processos = processos.filter(proc => {
                        return proc.controleGabinete?.numero === numero;
                    });
                }
                if (situacaoMinuta) {
                    const codigoSituacaoMinuta = parseInt(situacaoMinuta);
                    processos = processos.filter(proc => {
                        const minuta = proc.minutas.find(minuta => minuta.situacaoMinuta.codigo === codigoSituacaoMinuta);
                        return minuta;
                    });
                }
                if (ojc) {
                    processos = filtrarPorOjc(processos, ojc);
                }
                break;
            case 'julgamento':
                processos = processos.filter(proc => {
                    return proc.minutas.find(minuta => minuta.tipo.codigo === TipoMinuta.VOTO
                        && minuta.situacaoMinuta.codigo === SituacaoMinuta.LIBERADA_PARA_ASSINATURA_OU_INCLUSAO_EM_PAUTA
                        && minuta.vistoLiberado);
                });
                break;
            case 'pauta':
                // Recorte do Escaninho de Pauta: processos aguardando pauta ou sessão que
                // ou já possuem minuta de voto liberada para inclusão em pauta (mesmo recorte
                // do escaninho de julgamento) ou foram enviados à pauta por despacho/decisão
                // (GE-573) e estão fora do fluxo, precisando da criação da minuta de voto.
                processos = processos.filter(proc => {
                    if (proc.processoPautaFutura) {
                        return true;
                    }
                    if (!proc.aguardandoPautaOuSessao) {
                        return false;
                    }
                    const temVotoLiberado = proc.minutas.find(minuta => minuta.tipo.codigo === TipoMinuta.VOTO
                        && minuta.situacaoMinuta.codigo === SituacaoMinuta.LIBERADA_PARA_ASSINATURA_OU_INCLUSAO_EM_PAUTA
                        && minuta.vistoLiberado);
                    return Boolean(temVotoLiberado) || proc.precisaMinutaVotoParaPauta;
                });
                break;
            case 'peticao': {
                const procsForaDoGE = ProcessoStore._processosForaDoGE.slice();
                processos = [...processos, ...procsForaDoGE].filter(proc => {
                    return proc.quantidadePeticoesPendentes > 0;
                });
                break;
            }
            case 'voto-vencido':
                processos = processos.filter(proc => {
                    return proc.controleGabinete?.numero === ControleGabineteStore.buscarPorTipo(TipoControle.VOTOVENCIDO)?.numero;
                });
                break;
            case 'redator-designado':
                processos = processos.filter(proc => {
                    return proc.controleGabinete?.numero === ControleGabineteStore.buscarPorTipo(TipoControle.REDATORDESIGNADO).numero;
                });
                break;
            default:
                processos = [];
                break;
        }
        //processos = processos.sort((a, b) => new Date(b.dataUltimaModificacao).getTime() - new Date(a.dataUltimaModificacao).getTime());
        return processos;
    }

    get qtdProcessos() {
        return this.processosPorTipoEscaninhoFiltrado.length;
    }
}

export default new EscaninhoStore();
